import JassGameState from './gamestate';

/**
 * type igamestate
 */
export default class JassIGameState extends JassGameState {}
